import { render, staticRenderFns } from "./ModelPresetInput.vue?vue&type=template&id=f96c36fc&"
import script from "./ModelPresetInput.vue?vue&type=script&lang=js&"
export * from "./ModelPresetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports